import settingJson from "./settings.json";

export const settings = {
  checkPermission: true,
  version: settingJson.version,
  isDev: import.meta.env.VITE_IS_DEV == "true",
  mediaUrl: import.meta.env.VITE_MEDIA_URL,
};
